export default "__VITE_ASSET__ddf640e6__"